
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["account",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M256 0c-84.83 0-153.6 85.965-153.6 192S171.17 384 256 384s153.6-85.965 153.6-192S340.83 0 256 0zm0 358.4c-70.579 0-128-74.65-128-166.4S185.421 25.6 256 25.6 384 100.25 384 192s-57.421 166.4-128 166.4z"}}),_c('path',{attrs:{"d":"M367.812 361.762c-6.869 6.682-14.182 12.689-21.82 18.099 24.388 11.332 45.781 20.753 64.051 28.732 67.797 29.585 76.356 35.439 76.356 52.207 0 11.597-11.418 25.6-25.6 25.6H51.2c-14.182 0-25.6-14.003-25.6-25.6 0-16.768 8.559-22.622 76.348-52.207 18.278-7.979 39.671-17.399 64.051-28.732-7.637-5.41-14.95-11.418-21.82-18.099C37.598 410.539 0 417.075 0 460.8 0 486.4 22.921 512 51.2 512h409.6c28.279 0 51.2-25.6 51.2-51.2 0-43.725-37.598-50.261-144.188-99.038z"}})])
          )
        }
      }
    